import React, { Component } from "react";
import "./App.css";
import NavItems from "./NavItems";
import { Navbar } from "reactstrap";
import Content from "./Content";
import NotificationPage from "./NotificationPage";
import { Container, Row, Col } from "reactstrap";
import data from "./data";
import Home from "./Home";
import "@fortawesome/fontawesome-free/css/all.css";
import axios from "axios";

const backendURL = "https://ltr-code3-courtroomtestimonybe.azurewebsites.net/";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentScreen: data[0] // menu
    };
    this.currentTimePeriod = "week";
    this.subscription = {
      checkBoxes: {
        week: {},
        twoDays: {},
        today: {},
        allTips: {}
      },
      date: new Date(),
      emailSubscription: {
        email: "",
        isSubscribed: false
      },
      phoneSubscription: {
        phone: "",
        isSubscribed: false
      }
    };
    this.navigateByID = this.navigateByID.bind(this);
    this.setCheckBox = this.setCheckBox.bind(this);
    this.getTimePeriod = this.getTimePeriod.bind(this);
    this.determineTimePeriodsFromID = this.determineTimePeriodsFromID.bind(
      this
    );
    this.updateNotifications = this.updateNotifications.bind(this);
  }

  componentDidMount() {
    // if existing data, load existing data, else create base data
    // TODO connect with backend to get data?
    let localData;
    try {
      localData = JSON.parse(localStorage.getItem("CRT"));
      localData.date = new Date(localData.date);
    } catch (error) {
      console.log("either no local data, or broken local data", error);
    }
    if (localData) {
      this.subscription = localData;
    } else {
      data.forEach(obj => {
        if (obj.content) {
          obj.content.forEach(checkBoxItem => {
            if (checkBoxItem.text) {
              this.determineTimePeriodsFromID(obj.id).forEach(timePeriod => {
                this.subscription.checkBoxes[timePeriod][
                  checkBoxItem.text
                ] = false;
              });
            }
          });
        }
      });
    }
  }

  determineTimePeriodsFromID(id) {
    let timePeriods = [];
    if (data[1].navOptions.includes(id)) {
      timePeriods.push("today");
    }
    if (data[2].navOptions.includes(id)) {
      timePeriods.push("twoDays");
    }
    if (data[3].navOptions.includes(id)) {
      timePeriods.push("week");
    }
    if (data[14].navOptions.includes(id)) {
      timePeriods.push("allTips");
    }
    return timePeriods;
  }

  getTimePeriod() {
    return this.currentTimePeriod;
  }

  navigateByID(id) {
    // addressing multiple items being repeated in different time periods
    if (id === "7") this.currentTimePeriod = "allTips";
    if (id === "6") this.currentTimePeriod = "today";
    if (id === "5") this.currentTimePeriod = "twoDays";
    if (id === "4") this.currentTimePeriod = "week";

    let nextScreenIndex = data.findIndex(el => {
      return el.id === id;
    });
    if (nextScreenIndex && data[nextScreenIndex] !== this.state.currentScreen) {
      this.setState(prev => {
        return { previousState: prev };
      });
      this.setState({ currentScreen: data[nextScreenIndex] });
    }
  }

  updateNotifications() {
    localStorage.setItem("CRT", JSON.stringify(this.subscription));
    // commented out axios call as notifications are removed for the release
    // axios.post(
    //   backendURL,
    //   Object.assign(this.subscription, {
    //     email: this.subscription.emailSubscription.email
    //   })
    // );
    // axios call
  }

  setCheckBox(text) {
    this.subscription.checkBoxes[this.currentTimePeriod][text] = !this
      .subscription.checkBoxes[this.currentTimePeriod][text];
    this.updateNotifications();
  }

  render() {
    console.log(this.subscription);
    return (
      <div>
        <div className="header">
          <Navbar className="nav">
            <Col
              xs="1"
              sm="4"
              onClick={() => {
                this.setState(this.state.previousState);
              }}
            >
              {this.state.currentScreen.id === "1" ? null : (
                <i className="fas fa-chevron-left"></i>
              )}
            </Col>
            <Col xs="10" sm="4">
              <p className="title">{this.state.currentScreen.title}</p>
            </Col>
            <Col
              xs="1"
              sm="4"
              // onClick={() => {
              //   this.navigateByID("notifications");
              // }}
            >
              {/* {this.state.currentScreen.id === "notifications" ? null : (
                <i className="far fa-bell"></i>
              )} */}
            </Col>
          </Navbar>
          <Container>
            <Row>
              <Col>
                {this.state.currentScreen.id === "1" ? (
                  <p id="courtDateText">When is your court date?</p>
                ) : null}
              </Col>
            </Row>
          </Container>
        </div>
        <div
          id="services"
          className="services-area bg-gray default-padding bottom-less"
        >
          <Container>
            <div className="services-items">
              {this.state.currentScreen.id === "1" ? (
                <Home
                  data={this.state.currentScreen}
                  navTo={this.navigateByID}
                />
              ) : (
                <NavItems
                  data={this.state.currentScreen}
                  navTo={this.navigateByID}
                  subscription={this.subscription}
                />
              )}
            </div>
            <Row>
              <Col>
                <Content
                  data={this.state.currentScreen.content}
                  setCheckBox={this.setCheckBox}
                  getTimePeriod={this.getTimePeriod}
                  subscription={this.subscription}
                />
              </Col>
            </Row>
            {this.state.currentScreen.id === "notifications" ? (
              <NotificationPage
                subscription={this.subscription}
                updateNotifications={this.updateNotifications}
              />
            ) : null}
          </Container>
        </div>
      </div>
    );
  }
}

export default App;
